/* eslint-disable @typescript-eslint/ban-ts-comment */
import { Reducer } from 'redux'

import { useEffect } from 'react'

import { useDispatch, useStore } from 'react-redux'

import { ReducersList } from '../components/DynamicModuleLoader/DynamicModuleLoader'
import { ReduxStoreWithManager, StateSchemaKey } from '../config/StateSchema'

type ReducersListEntry = [StateSchemaKey, Reducer]

interface DynamicModuleLoaderProps {
  removeAfterUnmount?: boolean
  reducers: ReducersList
}

const useDynamicModuleLoader = ({
  removeAfterUnmount,
  reducers,
}: DynamicModuleLoaderProps) => {
  const store = useStore() as ReduxStoreWithManager
  const dispatch = useDispatch()

  useEffect(() => {
    //@ts-ignore
    Object.entries(reducers).forEach(([name, reducer]: ReducersListEntry) => {
      store.reducerManager.add(name, reducer)
      dispatch({ type: `@INIT ${name} reducer` })
    })

    return () => {
      if (removeAfterUnmount) {
        //@ts-ignore
        Object.entries(reducers).forEach(([name]: ReducersListEntry) => {
          store.reducerManager.remove(name)
          dispatch({ type: `@DESTROY ${name} reducer` })
        })
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}

export default useDynamicModuleLoader
